import { Spin, Timeline } from 'antd';
import { t } from 'i18next';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../../../../component/button/PrimaryButton';
import SecondaryButton from '../../../../component/button/SecondaryButton';
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import { LabelDetail, ValueDetail } from '../../../../component/page-components/detail';
import HeaderPages from '../../../../component/page-components/pages-header';
import { ROUTES } from '../../../../constant/routeConstant';
import useDetailTemperature from './detail-temperature.hooks';
import NotificationDelete from '../../../../component/modal/NofiticationDelete';
import { ActiveDotIcon, BackIcon, CloseIcon, InactiveDotIcon } from '../../../../asset';

const DetailTemperature = () => {
  const { data, handleBack, loading, toEdit, convertTimestamp, convertToTime, userManagementOpen, setUserManagementOpen, managementHistoryList } = useDetailTemperature();

  const [showDelete, setShowDelete] = useState(false);

  const setModal = async () => {
    await setShowDelete(true);
  }

  const navigate = useNavigate();

  const handleAction = () => {
    navigate(ROUTES.TEMPERATURE_CATEGORY.LIST)
  }

  return (
    <>
      <NotificationDelete
        updated_at={data?.updated_at}
        id={data?.temperature_category_id}
        visibleDelete={showDelete}
        title={data?.name}
        url={"temperature-category"}
        action={handleAction}
        route={ROUTES.TEMPERATURE_CATEGORY.LIST}
        setVisibleDelete={setShowDelete}
        handleCancel={() => setShowDelete(false)}
      />
      <div className=" p-5 h-fit">
        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`Temperature Category`}
          menuLevel4={`Detail - ${data?.code_name}`}
        />
        {loading ? (
          <Spin className="mt-5" />
        ) : (
          <>
            {/* <HeaderPages
              title="Detail"
              temperature
              temperature_code={data?.code_name}
              handleBack={handleBack}
            /> */}

            <div className='flex items-center justify-between my-[31px]' >
              <div className="flex items-center gap-[22px] cursor-pointer" onClick={() => handleBack()}>
                <img src={BackIcon} alt="" />
                <h1 className='font-sans-bold text-2xl' id='title'>{`Detail ${data?.name} - ${data?.code_name}`}</h1>
              </div>

              <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer' onClick={() => setUserManagementOpen(true)}>
                <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{data?.created_by_name}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(data?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} <strong>{data?.updated_by_name}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(data?.updated_at, true)}</strong></p>
              </div>
            </div>

            <div className=" bg-white-100 p-5 rounded-[10px] min-h-[500px]">
              <p className=' font-roboto text-lg text-black-100 font-bold'>
                Temperature Category Information
              </p>
              <div className=' mt-3 flex flex-row'>
                <div className=' min-w-96'>
                  <LabelDetail children='Category Name' />
                  <ValueDetail children={data?.name ? data?.name : '-'} />

                  <LabelDetail children='Temperature Code' />
                  <ValueDetail children={data?.code_name ? data?.code_name : '-'} />

                  <LabelDetail children='Description' />
                  <ValueDetail children={data?.description ? data?.description : '-'} />
                </div>
              </div>
            </div>
          </>
        )}
        <aside className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
          <button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
            <img src={CloseIcon} alt="" />
          </button>

          <h3 className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
          <p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{data?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(data?.created_at)}</strong></p>


          <div>
            <Timeline>
              {
                managementHistoryList.map((item, index) => {
                  if (index === 0) {
                    return (
                      <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                        <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                          <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
                          <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                          <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                        </div>
                      </Timeline.Item>
                    )
                  } else {
                    return (
                      <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                        <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                          <h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                          <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                          <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                        </div>
                      </Timeline.Item>
                    )
                  }
                })
              }
            </Timeline>
          </div>
        </aside>
      </div>
      <div className='flex flex-row-reverse gap-[16px] px-5 m-5'>
        <PrimaryButton action={toEdit} text={t("COMMON:BTN_EDIT")} />
        <SecondaryButton action={() => setModal(true)} text={t("COMMON:BTN_DELETE")} />
      </div>
    </>
  );
}

export default DetailTemperature;